export default __webpack_public_path__ + "static/media/create-package-icon.3de1f9aa.svg";